var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureLikeOff = function SvgGeneralFeatureLikeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "m12 21.3-8.941-8.942A5.27 5.27 0 0 1 1.5 8.607a5.27 5.27 0 0 1 1.555-3.752A5.27 5.27 0 0 1 6.806 3.3a5.27 5.27 0 0 1 3.752 1.554L12 6.296l1.442-1.442A5.27 5.27 0 0 1 17.195 3.3c1.417 0 2.749.552 3.752 1.554A5.27 5.27 0 0 1 22.5 8.606a5.27 5.27 0 0 1-1.559 3.752z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureLikeOff;